module.exports = __webpack_public_path__ + "img/canyon_light_ba_list.270a8789.jpg";